const PfsContent = `

nodes {
	name
	slug
}

`;

module.exports.PfsContent = PfsContent;
